"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionAccordion = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
require("../../../src/ui/sectionAccordion/sectionAccordion.module.scss");
var _ui = require("../../ui");
const _excluded = ["Action", "children", "className", "color", "icon", "opened", "title", "titleStyle", "variant", "onClose", "onOpen"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const SectionAccordion = exports.SectionAccordion = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      Action,
      children,
      className,
      color,
      icon,
      opened,
      title,
      titleStyle = {},
      variant,
      onClose,
      onOpen
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  const [isOpenedHook, setIsOpenedHook] = React.useState(opened);
  const [isMountChildren, setIsMountChildren] = React.useState(opened);
  const [isChangedHook, setIsChangedHook] = React.useState(false); // default без анимации, changed с анимацией

  const bodyRef = React.useRef(null);
  const headerRef = React.useRef(null);
  className = (0, _utils.ClassNames)('kui-section-accordion', color ? 'kui-section-accordion--color_' + color : null, variant ? 'kui-section-accordion--variant_' + variant : null, isChangedHook ? 'kui-section-accordion--' + (isOpenedHook ? 'opened' : 'closed') : isOpenedHook ? 'kui-section-accordion--opened-default' : null, className);
  const setIsOpened = newIsOpened => {
    if (newIsOpened) setIsMountChildren(true);
    setIsOpenedHook(newIsOpened);
    setIsChangedHook(true);
  };
  const onButtonClick = () => {
    if (isOpenedHook) {
      if (onClose) onClose();
    } else {
      if (onOpen) onOpen();
    }
    setIsOpened(!isOpenedHook);
  };
  const bodyAnimationEnd = () => {
    if (isOpenedHook) {
      if (!(0, _utils.userAgentsInclude)(['edge', 'safari'])) setTimeout(() => {
        headerRef.current.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }, 100);
    } else {
      setIsMountChildren(false);
    }
  };
  React.useEffect(() => {
    if (opened === isOpenedHook) return;
    setIsOpened(opened);
  }, [opened]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: ref
  }, attributes), /*#__PURE__*/React.createElement("div", {
    className: "kui-section-accordion-header",
    ref: headerRef
  }, /*#__PURE__*/React.createElement(_ui.Button, {
    className: "kui-section-accordion-button",
    variant: "icon-text",
    "aria-expanded": isOpenedHook,
    onClick: onButtonClick
  }, icon && /*#__PURE__*/React.createElement(_ui.Icon, {
    className: "kui-section-accordion-button__icon",
    size: 24,
    xlink: icon
  }), /*#__PURE__*/React.createElement(_ui.ButtonTitle, {
    className: "kui-section-accordion-button__title",
    style: titleStyle
  }, title), /*#__PURE__*/React.createElement(_ui.Icon, {
    className: "kui-section-accordion-button__icon kui-section-accordion__arrow",
    size: 24,
    xlink: 'arrow-s-drop-open'
  })), Action && /*#__PURE__*/React.createElement("div", {
    className: "kui-section-accordion-action"
  }, /*#__PURE__*/React.createElement(Action, {
    className: "kui-section-accordion-action__button"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "kui-section-accordion-body",
    "aria-hidden": !isOpenedHook,
    hidden: !isMountChildren,
    ref: bodyRef,
    onAnimationEnd: bodyAnimationEnd
  }, isMountChildren && children));
});
SectionAccordion.defaultProps = {
  Action: null,
  color: null,
  icon: null,
  title: null,
  opened: false,
  variant: null,
  onClose: () => undefined,
  onOpen: () => undefined
};
SectionAccordion.displayName = 'SectionAccordion';